// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import SellerRoute from './components/SellerRoute';

// Лэйаут и компоненты
import Header from './components/Header';
import Footer from './components/Footer';

// Страницы
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import FlightSheetForm from './pages/FlightSheetForm';
import FlightSheetEdit from './pages/FlightSheetEdit';
import FlightSheetDashboard from './pages/FlightSheetDashboard';
import AdminDashboard from './pages/AdminDashboard';
import NotFound from './pages/NotFound';

// Новые страницы для реферальной системы
import ReferralLinks from './pages/ReferralLinks';
import ReferralLinkForm from './pages/ReferralLinkForm';
import Referrals from './pages/Referrals';
import AdminSellers from './pages/AdminSellers';
import AdminReferralLinks from './pages/AdminReferralLinks';
import AdminUsers from './pages/AdminUsers';
import AdminFlightSheets from './pages/AdminFlightSheets';
import AdminStats from './pages/AdminStats';

// Импортируем стили
import './theme.css'; // Наша новая тема
import './App.css';

// Фоновые частицы (добавлен pointer-events: none)
const ParticlesBackground = () => {
    return (
        <div className="particles-container" style={{ pointerEvents: 'none', zIndex: -20 }}>
            <div className="particle particle-1" style={{ pointerEvents: 'none' }}></div>
            <div className="particle particle-2" style={{ pointerEvents: 'none' }}></div>
            <div className="particle particle-3" style={{ pointerEvents: 'none' }}></div>
            <div className="particle particle-4" style={{ pointerEvents: 'none' }}></div>
        </div>
    );
};

function App() {
    return (
        <AuthProvider>
            <Router>
                <div className="app-wrapper">
                    <ParticlesBackground />
                    <Header />
                    <main className="py-4" style={{ minHeight: 'calc(100vh - 136px)', position: 'relative', zIndex: 10 }}>
                        <Routes>
                            {/* Публичные маршруты */}
                            <Route path="/login" element={<Login />} />
                            <Route path="/register" element={<Register />} />

                            {/* Приватные маршруты */}
                            <Route path="/dashboard" element={
                                <PrivateRoute>
                                    <Dashboard />
                                </PrivateRoute>
                            } />
                            <Route path="/flight-sheets/new" element={
                                <PrivateRoute>
                                    <FlightSheetForm />
                                </PrivateRoute>
                            } />
                            <Route path="/flight-sheets/:id" element={
                                <PrivateRoute>
                                    <FlightSheetDashboard />
                                </PrivateRoute>
                            } />
                            <Route path="/flight-sheets/:id/edit" element={
                                <PrivateRoute>
                                    <FlightSheetEdit />
                                </PrivateRoute>
                            } />

                            {/* Маршруты для селлеров */}
                            <Route element={<SellerRoute />}>
                                <Route path="/referrals/links" element={<ReferralLinks />} />
                                <Route path="/referrals/links/new" element={<ReferralLinkForm />} />
                                <Route path="/referrals/links/:id/edit" element={<ReferralLinkForm />} />
                                <Route path="/referrals/users" element={<Referrals />} />
                            </Route>

                            {/* Административные маршруты */}
                            <Route element={<AdminRoute />}>
                                <Route path="/admin" element={<AdminDashboard />} />
                                <Route path="/admin/users" element={<AdminUsers />} />
                                <Route path="/admin/flight-sheets" element={<AdminFlightSheets />} />
                                <Route path="/admin/stats" element={<AdminStats />} />
                                <Route path="/admin/sellers" element={<AdminSellers />} />
                                <Route path="/admin/referral-links" element={<AdminReferralLinks />} />
                            </Route>

                            {/* Редирект с корня на дашборд */}
                            <Route path="/" element={<Navigate to="/dashboard" replace />} />

                            {/* Обработка не найденных страниц */}
                            <Route path="*" element={<NotFound />} />
                        </Routes>
                    </main>
                    <Footer />
                </div>
            </Router>
        </AuthProvider>
    );
}

export default App;